import { PropsWithChildren, useState } from 'react';
import { generatePath } from 'react-router-dom';
import styled from 'styled-components';

import ButtonBase from '@sorare/core/src/atoms/buttons/ButtonBase';
import Dialog from '@sorare/core/src/components/dialog';
import { FOOTBALL_PLAY_RIVALS_LEAGUES_SLUG_MEMBERS } from '@sorare/core/src/constants/__generated__/routes';
import { useIsDesktopAndAbove } from '@sorare/core/src/hooks/device/useIsDesktopAndAbove';
import { Link } from '@sorare/core/src/routing/Link';

import { MembersList } from 'components/rivalsUserGroup/MembersList';

const Wrapper = styled.div``;

type Props = {
  userGroupSlug: string;
};

export const ToMembersList = ({
  children,
  userGroupSlug,
}: PropsWithChildren<Props>) => {
  const isDesktopAndAbove = useIsDesktopAndAbove();
  const [dialogOpen, setDialogOpen] = useState(false);
  if (isDesktopAndAbove) {
    return (
      <Wrapper>
        <ButtonBase onClick={() => setDialogOpen(true)}>{children}</ButtonBase>
        <Dialog open={dialogOpen}>
          <MembersList userGroupSlug={userGroupSlug} />
        </Dialog>
      </Wrapper>
    );
  }
  return (
    <Link
      to={generatePath(FOOTBALL_PLAY_RIVALS_LEAGUES_SLUG_MEMBERS, {
        slug: userGroupSlug,
      })}
    >
      {children}
    </Link>
  );
};
